import clsx from 'clsx';
import Text from '@/components/Text/Text';
import Img from '@/components/Img';
import styles from './TestimonialSection.module.scss';

export interface TestimonialProps {
  author: string;
  id: number;
  review: string;
  quote: string;
  backgroundColor?: 'dark' | 'light';
  authorImage?: {
    id: number;
    url: string;
    width: number;
    height: number;
    alternativeText: string;
  };
  logo?: {
    id: number;
    url: string;
    width: number;
    height: number;
  };
}

const Testimonial = ({ data }: { data: TestimonialProps }) => (
  <section className={styles.testimonialWrapper}>
    <section className={clsx(styles.testimonial, { [styles.dark]: data.backgroundColor === 'dark' })}>
      <Text
        tag='h4'
        className={styles.quote}
      >
        {data.review}
      </Text>
      <div className={styles.author}>
        {data.authorImage && (
          <div className={styles.authorImage}>
            <Img
              src={data.authorImage.url}
              width={64}
              height={64}
              alt={data.authorImage.alternativeText || data.author}
            />
          </div>
        )}
        <div className={styles.authorDescription}>
          <Text
            tag='p'
            isSemiBold
          >
            {data.author}
          </Text>
          {data.logo && (
            <div className={styles.logo}>
              <Img
                src={data.logo.url}
                width={data.logo.width}
                height={data.logo.height}
                alt='Company logo'
              />
            </div>
          )}
        </div>
      </div>
    </section>
  </section>
);
export default Testimonial;
